export const TemplatePermissionType = {
	NO_ACCESS: "NO_ACCESS",
	READ_ONLY_WITH_WATERMARK: "LEITURA_MARCA_DAGUA",
	READ_ONLY: "LEITURA",
	EDITION: "EDICAO"
};

export default TemplatePermissionType;
